import React from "react";
import { Grid, Button, Switch } from "@material-ui/core";
import styled from "styled-components";
import ICompany from "../../models/ICompany";
import CompanySelect from "../CompanySelect";
import AddIcon from "@material-ui/icons/Add";
import { Link } from "react-router-dom";

const SettingsGrid = styled(Grid)`
  padding: 0 1em;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  margin-bottom: 2em;
`;

const ActionSettingsGrid = styled(Grid)`
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
`;

const FilterSettingsGrid = styled(Grid)`
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
`;

const Setting = styled(Grid)`
  display: flex;
  margin: 0 1em;
  align-items: center;

  & a {
    text-decoration: none;
  }
`;

const SettingButton = styled(Button)`
  height: 56px;
`;

const SettingSwitch = styled(Switch)`
  vertical-align: middle;
`;

const SwitchLabel = styled.div<{ isActive: boolean }>`
  display: inline-block;

  ${props =>
    props.isActive &&
    `
    font-weight: 600;
  `}
`;

export interface IContactControlSettings {
  company: ICompany;
  showInactive: boolean;
}

function onShowInactiveChange(doShow: boolean) {}

export interface IContactListControlsProps {
  company: ICompany;
  showInactive: boolean;
  onShowInactiveChange: typeof onShowInactiveChange;
}

const ContactListControls = (props: IContactListControlsProps) => {
  const { company, showInactive, onShowInactiveChange } = props;

  return (
    <SettingsGrid container>
      <FilterSettingsGrid>
        <Setting item>
          <CompanySelect />
        </Setting>
        <Setting item>
          <SwitchLabel isActive={showInactive}>All</SwitchLabel>
          <SettingSwitch checked={!showInactive} onChange={() => onShowInactiveChange(!showInactive)} color="default" />
          <SwitchLabel isActive={!showInactive}>Active</SwitchLabel>
        </Setting>
      </FilterSettingsGrid>
      {company.Type == "Vendor" && (
        <ActionSettingsGrid>
          <Setting item>
            <Link to="/users/add?returnUrl='/users/list'">
              <SettingButton variant="outlined" color="primary" size="large" startIcon={<AddIcon />}>
                Add New
              </SettingButton>
            </Link>
          </Setting>
        </ActionSettingsGrid>
      )}
    </SettingsGrid>
  );
};

export default ContactListControls;
